var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.displayHeaders,
          height: _vm.tableSize,
          items: _vm.filteredItems,
          "items-per-page": _vm.pageSize,
          loading: _vm.loading,
          search: _vm.search,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          dense: "",
          "fixed-header": "",
          "item-key": "ad_plan_id",
          "loading-text": "Loading... Please Wait",
          "no-results-text": "No matching items found",
          "no-data-text": _vm.selectedAdGroup
            ? "No current or future ad planner items found"
            : "Select an ad group to view ad planner items",
        },
        on: {
          "update:sortBy": function ($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function ($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function ($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function ($event) {
            _vm.sortDesc = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "top",
              fn: function () {
                return [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "py-2",
                      staticStyle: { cursor: "default" },
                      attrs: { flat: "", color: "toolbar", height: "auto" },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "", align: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("v-toolbar-title", [
                                _vm._v("Ad Planner Query"),
                              ]),
                              _c("v-divider", {
                                staticClass: "mx-4",
                                attrs: { vertical: "", inset: "" },
                              }),
                              _c(
                                "span",
                                { staticClass: "text-caption grey--text" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.items.length.toLocaleString()
                                      ) +
                                      " items across " +
                                      _vm._s(_vm.plannerCount) +
                                      " current/future planners "
                                  ),
                                ]
                              ),
                              _vm.loadWarning
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ml-3",
                                      attrs: {
                                        small: "",
                                        color: "amber",
                                        "text-color": "white",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-alert-outline")]
                                      ),
                                      _vm._v(_vm._s(_vm.loadWarning) + " "),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: { outlined: "" },
                                  on: { click: _vm.openColumnsModal },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-table-cog"),
                                  ]),
                                  _vm._v("Columns "),
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    outlined: "",
                                    disabled: !_vm.filteredItems.length,
                                  },
                                  on: { click: _vm.exportCsv },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-download"),
                                  ]),
                                  _vm._v("CSV "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "3", lg: "2" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  "auto-select-first": "",
                                  items: _vm.userAdGroups,
                                  "item-text": "name",
                                  "item-value": "id",
                                  "return-object": "",
                                  "hide-no-data": "",
                                  "background-color": "input",
                                  label: "Ad Group",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                  "prepend-inner-icon": "mdi-filter-outline",
                                  "menu-props": { maxHeight: 260 },
                                },
                                model: {
                                  value: _vm.selectedAdGroup,
                                  callback: function ($$v) {
                                    _vm.selectedAdGroup = $$v
                                  },
                                  expression: "selectedAdGroup",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "4", lg: "3" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "background-color": "input",
                                  label: "Search",
                                  placeholder: "Search all columns...",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                  clearable: "",
                                  "prepend-inner-icon": "mdi-magnify",
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "2", lg: "2" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.positionOptions,
                                  label: "Position",
                                  multiple: "",
                                  chips: "",
                                  "small-chips": "",
                                  "deletable-chips": "",
                                  clearable: "",
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  "background-color": "input",
                                  "menu-props": { maxHeight: 300 },
                                },
                                model: {
                                  value: _vm.filters.positions,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "positions", $$v)
                                  },
                                  expression: "filters.positions",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "2", lg: "2" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.departmentOptions,
                                  label: "Department",
                                  multiple: "",
                                  chips: "",
                                  "small-chips": "",
                                  "deletable-chips": "",
                                  clearable: "",
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  "background-color": "input",
                                  "menu-props": { maxHeight: 300 },
                                },
                                model: {
                                  value: _vm.filters.departments,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "departments", $$v)
                                  },
                                  expression: "filters.departments",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "2", lg: "2" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.promoCategoryOptions,
                                  label: "Promo Category",
                                  multiple: "",
                                  chips: "",
                                  "small-chips": "",
                                  "deletable-chips": "",
                                  clearable: "",
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  "background-color": "input",
                                  "menu-props": { maxHeight: 300 },
                                },
                                model: {
                                  value: _vm.filters.promoCategories,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "promoCategories",
                                      $$v
                                    )
                                  },
                                  expression: "filters.promoCategories",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "2", lg: "2" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.vendorOptions,
                                  label: "Vendor",
                                  multiple: "",
                                  chips: "",
                                  "small-chips": "",
                                  "deletable-chips": "",
                                  clearable: "",
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  "background-color": "input",
                                  "menu-props": { maxHeight: 300 },
                                },
                                model: {
                                  value: _vm.filters.vendors,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "vendors", $$v)
                                  },
                                  expression: "filters.vendors",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "2", lg: "2" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.epayCompeteOptions,
                                  label: "ePay/Competes",
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "",
                                  "background-color": "input",
                                },
                                model: {
                                  value: _vm.filters.epayCompetes,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "epayCompetes", $$v)
                                  },
                                  expression: "filters.epayCompetes",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-center",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    small: "",
                                    disabled: !_vm.filtersActive,
                                  },
                                  on: { click: _vm.clearFilters },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-filter-remove-outline")]
                                  ),
                                  _vm._v("Clear "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: `item.ad_start_date`,
              fn: function ({ item }) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatDateDisplay(item.ad_start_date)) +
                      " "
                  ),
                ]
              },
            },
            {
              key: `item.ad_end_date`,
              fn: function ({ item }) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.formatDateDisplay(item.ad_end_date)) + " "
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", persistent: "" },
          model: {
            value: _vm.showColumnsModal,
            callback: function ($$v) {
              _vm.showColumnsModal = $$v
            },
            expression: "showColumnsModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "accent white--text pa-3 justify-center" },
                [_vm._v("Ordering Headers")]
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("h3", { staticClass: "text-center mb-2" }, [
                            _vm._v("Display Order"),
                          ]),
                          _c(
                            "draggable",
                            {
                              staticClass: "list-group",
                              attrs: {
                                list: _vm.displayHeadersDraft,
                                group: "headers",
                              },
                              on: { end: _vm.onDragEnd },
                            },
                            _vm._l(_vm.displayHeadersDraft, function (header) {
                              return _c(
                                "div",
                                {
                                  key: header.value,
                                  staticClass: "list-group-item pa-2 my-1",
                                },
                                [_vm._v(" " + _vm._s(header.text) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("h3", { staticClass: "text-center mb-2" }, [
                            _vm._v("Hide"),
                          ]),
                          _c(
                            "draggable",
                            {
                              staticClass: "list-group",
                              attrs: {
                                list: _vm.hideHeadersDraft,
                                group: "headers",
                              },
                              on: { end: _vm.onDragEnd },
                            },
                            _vm._l(_vm.hideHeadersDraft, function (header) {
                              return _c(
                                "div",
                                {
                                  key: header.value,
                                  staticClass: "list-group-item pa-2 my-1",
                                },
                                [_vm._v(" " + _vm._s(header.text) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "grey lighten-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent white--text" },
                      on: { click: _vm.resetHeaders },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1 white--text" },
                      on: { click: _vm.saveHeadersOrder },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }